import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/shares/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/shares/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/shares/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/shares/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/shares/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/shares` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/shares?title=${title}` , { headers: authHeader() });
};

const SharesService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default SharesService;
